import React, { useState } from "react";
import { Tabs } from "antd";
import QrCccdScanner from "./QrCCCDScanner";
import CreateBankQR from "./CreateBankQR/index";
import QrBooking from "./QrBooking/index";

const listTab = [
  {
    key: "cccd",
    label: "Quét QR CCCD",
    children: <QrCccdScanner />,
  },
  {
    key: "qr-code",
    label: "Tạo mã QR",
    children: <CreateBankQR />,
  },
  {
    key: "qr-booking",
    label: "QR Đặt lịch",
    children: <QrBooking />,
  },
];

const Utilities = () => {
  const [activeKey, setActiveKey] = useState("cccd");
  return <Tabs items={listTab} activeKey={activeKey} onChange={setActiveKey} />;
};

export default Utilities;
